import React, { FC } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { MRList } from './MRList'

const MRListWrapper: FC = () => {
    return (
        <>
            <PageTitle breadcrumbs={[]}>MR List</PageTitle>
            <MRList />
        </>
    )
}

export default MRListWrapper
